import { Component, OnInit } from '@angular/core';
import { BrandService } from '@features/brand/services/brand.service';

@Component({
  selector: 'fc-brand-dropdown',
  templateUrl: './brand-dropdown.component.html',
  styleUrls: ['./brand-dropdown.component.css'],
})
export class BrandDropdownComponent implements OnInit {
  brands: any[] = [];
  constructor(private brandService: BrandService) {
    this.brandService.getBrands().subscribe((brands) => {
      this.brands = brands;
    });
  }

  ngOnInit(): void {}
}
